import { useMemo } from "react";

export const useAlignment = (alignment: string, S: { [key: string]: string }) => {
    const alignmentClass = useMemo(() => {
        switch (alignment) {
            case "ITEMS_ALIGNMENT_LEFT":
                return S.alignmentLeft;
            case "ITEMS_ALIGNMENT_TOP":
                return S.alignmentTop;
        }
    }, [alignment, S]);

    return {
        alignmentClass,
    };
};
